import { Avatar, Box, Drawer, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { getInternStudent, getInternshipRequest } from "../api/crud";
import ModalCrudCompany2 from "../Components/company-form/ModalCrudCompany2";
import InternData from "../Components/InternData";
import ProfileDetail from "../Components/ProfileDetail";
import { optionsBranch } from "../data/branch-data";
import SummaryCardEl from "../Elements/SummaryCardEl";
import SummaryCardEl2 from "../Elements/SummaryCardEl2";
import { convertDateToString, convertTime, timeSince } from "../utils/function";
import { generateStatus } from "../utils/generateDisplay";
import ActivityLog from "../Components/ActivityLog";
import { BiDotsVerticalRounded } from "react-icons/bi";
import ModalView from "../Components/ModalView";
import dayjs from "dayjs";

const Dashboard = () => {
  const navigate = useNavigate();
  const optionsNewBranch = [
    {
      label: "ทั้งหมด",
      value: 0,
    },
    ...optionsBranch,
  ];
  const getStatus = window.localStorage.getItem("status");
  const profile = useSelector((state) => state.profileReducer.profile);
  const [internStudentList, setInternStudentList] = useState([]);
  const [internStudentList2, setInternStudentList2] = useState([]);
  const [internStudentList3, setInternStudentList3] = useState([]);
  const [internStudentActive, setinternStudentActive] = useState([]);
  const [internType1, setinternType1] = useState([]);
  const [internType2, setinternType2] = useState([]);
  const [internType3, setinternType3] = useState([]);

  const [internType1a, setinternType1a] = useState([]);
  const [internType2a, setinternType2a] = useState([]);
  const [internType3a, setinternType3a] = useState([]);

  const [internFilterTypeList, setInternFilterTypeList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [internRequest, setInternRequest] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [studentSelected, setStudentSelected] = useState(null);
  const [branchSelected, setBranchSelected] = useState(optionsNewBranch[0]);
  const [statusFocused, setStatusFocused] = useState(0);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModal2, setIsOpenModal2] = useState(false);
  const [modalChartOpen, setModalChartOpen] = useState(false);
  const [modalChartOpen2, setModalChartOpen2] = useState(false);

  useEffect(() => {
    if (getStatus === "student") {
      navigate("/");
    }
  }, [getStatus]);

  const matchOptions = (options, value = "") => {
    const match = options.find((item) => item.value == value);

    return match ? match.label : "-";
  };

  const onHandleBranchSelect = (data) => {
    setBranchSelected(data);
  };

  const onSearchChange = (ev) => {
    setSearchTerm(ev.target.value);

    const results = internFilterTypeList.filter((item) => {
      return (
        item.id.toLowerCase().includes(ev.target.value.toLowerCase()) ||
        item.name.toLowerCase().includes(ev.target.value.toLowerCase()) ||
        item.status_byuser
          .toLowerCase()
          .includes(ev.target.value.toLowerCase()) ||
        item.branch_name?.toLowerCase().includes(ev.target.value.toLowerCase())
      );
    });

    setFilterList(results);
  };

  const getInternStudentList = async () => {
    const internshipRequest = await getInternshipRequest();
    const activeInternshipRequest = internshipRequest.filter(
      (res) => res.status !== "0" && res.req_id
    );

    await getInternStudent()
      .then((res) => {
        const list = res.map((el) => {
          const matchIntern = activeInternshipRequest.find(
            (item) => item.st_id === el.id
          );

          return {
            ...el,
            branch_name: matchOptions(optionsBranch, el.b_id),
            internshipRequest: matchIntern,
          };
        });

        const studentByBranch = list.filter((student) => {
          if (branchSelected.value == 0) {
            return student;
          } else {
            return student.b_id == branchSelected.value;
          }
        });

        const internStdActive = list.filter((st) => st.internshipRequest);

        const filterType1 = studentByBranch.filter(
          (item) => item?.internshipRequest?.type_internship == "1"
        );
        const filterType2 = studentByBranch.filter(
          (item) => item?.internshipRequest?.type_internship == "2"
        );
        const filterType3 = studentByBranch.filter(
          (item) => item?.internshipRequest?.type_internship == "3"
        );

        const filterType1a = internStdActive.filter(
          (item) => item?.internshipRequest?.type_internship == "1"
        );
        const filterType2a = internStdActive.filter(
          (item) => item?.internshipRequest?.type_internship == "2"
        );
        const filterType3a = internStdActive.filter(
          (item) => item?.internshipRequest?.type_internship == "3"
        );

        setinternType1a(filterType1a);
        setinternType2a(filterType2a);
        setinternType3a(filterType3a);

        setinternStudentActive(studentByBranch);

        setinternType1(filterType1);
        setinternType2(filterType2);
        setinternType3(filterType3);

        setInternStudentList(studentByBranch);
        setInternStudentList2(list);
        setInternStudentList3(internStdActive);
        setInternFilterTypeList(studentByBranch);
        setFilterList(studentByBranch);

        const unRequest = res.filter(
          (el) => el.status_id > 0 && el.status_id <= 3
        );

        setInternRequest(unRequest);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (profile && profile.b_id) {
      const matchBranch = optionsBranch.find(
        (opt) => opt.value == profile.b_id
      );

      setBranchSelected(matchBranch);
    }
  }, [profile]);

  useEffect(() => {
    getInternStudentList();
  }, [branchSelected]);

  const ProgressBarEl = ({ stList = [], bgColor, statusId, statusIdPrev }) => {
    return (
      <div
        className="progress-bar"
        role="progressbar"
        aria-label="Segment two"
        style={{
          width: `${
            (stList.filter((el) => el.status_id == statusId).length /
              stList.length) *
            100
          }%`,
          backgroundColor: bgColor,
        }}
        aria-valuenow={stList.filter((el) => el.status_id == statusId).length}
        aria-valuemin={
          statusIdPrev
            ? stList.filter((el) => el.status_id == statusIdPrev).length
            : 0
        }
        aria-valuemax={stList.length}
      />
    );
  };

  const displayTable = (
    <>
      <div className="card-header">
        <div
          className="d-flex justify-content-between  flex-wrap"
          style={{ minHeight: "50px" }}
        >
          <h5 className="card-title ">
            รายชื่อนิสิต{branchSelected?.label} {generateStatus(statusFocused)}
          </h5>
          <div>
            <input
              type="text"
              style={{ maxWidth: 300 }}
              className="form-control"
              placeholder="ค้นหา"
              onChange={onSearchChange}
              value={searchTerm}
            />

            <div>{!!searchTerm && `พบ ${filterList.length} ผลลัพธ์`} </div>
          </div>
        </div>
      </div>

      <div className="overflow-auto">
        <table
          id="datatables-dashboard-projects"
          className="table table-striped my-0 table-hover"
        >
          <thead>
            <tr className="text-nowrap">
              <th>รหัสนิสิต</th>
              <th>ชื่อ - สกุล</th>
              <th>สาขา</th>
              <th>สถานะ</th>
              <th>อัพเดทเมื่อ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!!filterList.length &&
              filterList.map((item) => {
                return (
                  <tr
                    className="text-nowrap"
                    key={item.id}
                    onClick={() => {
                      setStudentSelected(item);
                    }}
                    role="button"
                  >
                    <td>{item.id}</td>
                    <td>
                      <span className="d-flex">
                        <Avatar
                          alt="profile"
                          sx={{ width: 25, height: 25 }}
                          src={`http://reg.buu.ac.th/registrar/getstudentimage.asp?id=${item.id}`}
                        />
                        <span className="ms-2">{item.name}</span>
                      </span>
                    </td>
                    <td>
                      {/* {matchOptions(optionsBranch, item.b_id)} */}
                      {item.branch_name}
                    </td>

                    <td>{generateStatus(item.status_id)}</td>
                    <td>
                      <span>
                        {convertDateToString(item.timeStamp)}{" "}
                        {convertTime(item.timeStamp)}{" "}
                      </span>
                      <div>
                        <small>
                          {item.status_byuser && isNaN(item.status_byuser)
                            ? `โดย ${item.status_byuser}`
                            : ""}
                        </small>
                      </div>
                    </td>
                    <td>
                      <span
                        className="badge"
                        style={{ background: "#FEFAC2", color: "gray" }}
                      >
                        {timeSince(item.timeStamp)}
                      </span>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );

  const displayProfile = (
    <Drawer
      anchor="right"
      open={studentSelected ? true : false}
      onClose={() => setStudentSelected(null)}
    >
      <div
        className="card-body shadow-lg"
        style={{ width: "80vw", maxWidth: "600px" }}
      >
        <div className="row g-0">
          {(studentSelected?.status_id == "0" ||
            studentSelected?.status_id == "32" ||
            studentSelected?.status_id == "14" ||
            studentSelected?.status_id == "15") && (
            <div className="col-12 text-end p-2">
              <span className="dropdown">
                <BiDotsVerticalRounded
                  size="1.5rem"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                />
                <ul className="dropdown-menu">
                  <li>
                    <form action="./cancel-register.php" method="post">
                      <input
                        className="d-none"
                        defaultValue={studentSelected?.id}
                        name="st_id"
                      />
                      <input
                        className="d-none"
                        defaultValue={profile?.id}
                        name="user"
                      />
                      <button
                        className="btn btn-light dropdown-item"
                        type="submit"
                      >
                        ยกเลิก
                      </button>
                    </form>
                  </li>
                </ul>
              </span>
            </div>
          )}
          <div className="col-12 mb-4">
            <ProfileDetail st_id={studentSelected?.id} />
          </div>
          <div className="col-12 ">
            <InternData st_id={studentSelected?.id} />
          </div>
        </div>

        <hr />
        <ActivityLog />
      </div>
    </Drawer>
  );

  const displayDashboard = (
    <div className="main">
      <main className="content">
        <div className="container-fluid p-0">
          <div className="d-flex justify-content-between align-items-center my-3">
            <div className="">
              <h1>
                สรุปการฝึกงานและสหกิจศึกษาปี {new Date().getFullYear() + 543}
              </h1>
            </div>
            <div className="">
              <Select
                options={optionsNewBranch}
                value={branchSelected}
                onChange={onHandleBranchSelect}
                isDisabled={profile && profile.b_id == 0 ? false : true}
              />
            </div>
          </div>
          <div class="row">
            <div className="col-md-4">
              <div
                className="card shadow border-success"
                role="button"
                onClick={() => setModalChartOpen(true)}
              >
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>สถานะการฝึกงานของนิสิต</div>
                    <div>
                      {internStudentList.filter((el) => el.status_id != 0)
                        .length -
                        internStudentList.filter((el) => el.status_id == 32)
                          .length -
                        internStudentList.filter((el) => el.status_id == 15)
                          .length -
                        internStudentList.filter((el) => el.status_id == 14)
                          .length}{" "}
                      / {internStudentList.length}
                    </div>
                  </div>
                  <div className="progress">
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="#F7F759"
                      statusId={11}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="blue"
                      statusId={1}
                      statusIdPrev={11}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="green"
                      statusId={12}
                      statusIdPrev={1}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="orange"
                      statusId={2}
                      statusIdPrev={12}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="#F1D507"
                      statusId={21}
                      statusIdPrev={2}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="#1876D1"
                      statusId={3}
                      statusIdPrev={21}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="#00FF15"
                      statusId={31}
                      statusIdPrev={3}
                    />
                  </div>
                </div>
              </div>

              <div
                className="card shadow border-success"
                role="button"
                onClick={() => setModalChartOpen2(true)}
              >
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>ฝึกงาน 2 เดือน</div>
                    <div>สหกิจศึกษา</div>
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-label="type-1"
                      style={{
                        width: `${Math.round(
                          (internType1.length /
                            (internStudentActive.filter(
                              (el) => el.status_id != 0
                            ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 15
                              ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 32
                              ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 14
                              ).length)) *
                            100
                        )}%`,
                      }}
                      aria-valuenow={Math.round(
                        (internType1.length /
                          (internStudentActive.filter((el) => el.status_id != 0)
                            .length -
                            internStudentActive.filter(
                              (el) => el.status_id == 15
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 32
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 14
                            ).length)) *
                          100
                      )}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      {`${Math.round(
                        (internType1.length /
                          (internStudentActive.filter((el) => el.status_id != 0)
                            .length -
                            internStudentActive.filter(
                              (el) => el.status_id == 15
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 32
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 14
                            ).length)) *
                          100
                      )}%`}
                    </div>
                    <div
                      className="progress-bar bg-success"
                      role="progressbar"
                      aria-label="type-2-3"
                      style={{
                        width: `${Math.round(
                          ([...internType2, ...internType3].length /
                            (internStudentActive.filter(
                              (el) => el.status_id != 0
                            ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 15
                              ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 32
                              ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 14
                              ).length)) *
                            100
                        )}%`,
                      }}
                      aria-valuenow={Math.round(
                        (internType1.length /
                          (internStudentActive.filter((el) => el.status_id != 0)
                            .length -
                            internStudentActive.filter(
                              (el) => el.status_id == 15
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 32
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 14
                            ).length)) *
                          100
                      )}
                      aria-valuemin={Math.round(
                        ([...internType2, ...internType3].length /
                          (internStudentActive.filter((el) => el.status_id != 0)
                            .length -
                            internStudentActive.filter(
                              (el) => el.status_id == 15
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 32
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 14
                            ).length)) *
                          100
                      )}
                      aria-valuemax={100}
                    >
                      {`${Math.round(
                        ([...internType2, ...internType3].length /
                          (internStudentActive.filter((el) => el.status_id != 0)
                            .length -
                            internStudentActive.filter(
                              (el) => el.status_id == 15
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 32
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 14
                            ).length)) *
                          100
                      )}%`}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="row">
                <SummaryCardEl
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={0}
                  data={internStudentList}
                  title="ลงทะเบียนขอฝึกงานและสหกิจศึกษา"
                  qtyColorText=""
                  cardWidth="100%"
                />

                <SummaryCardEl
                  cardWidth="100%"
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={101}
                  data={internType1}
                  title="ฝึกงาน 2 เดือน"
                  qtyColorText=""
                />
                <SummaryCardEl
                  cardWidth="100%"
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={102}
                  data={[...internType2, ...internType3]}
                  title="สหกิจศึกษา"
                  qtyColorText=""
                />
              </div>
            </div>
          </div>

          <div style={{ display: "flex", overflowX: "scroll", gap: "5px" }}>
            <SummaryCardEl2
              cardWidth="250px"
              setStatusFocused={setStatusFocused}
              statusFocused={statusFocused}
              setFilterList={setFilterList}
              setInternFilterTypeList={setInternFilterTypeList}
              status_id={31}
              data={internStudentList.filter((el) => el.status_id == 31)}
              title="สถานประกอบการรับเข้าฝึกงาน"
              total={internStudentList.length}
              // filter((el) => el.status_id != 0 )
              // .length -internStudentList.filter((el) => el.status_id == 15 ).length
              // -internStudentList.filter((el) => el.status_id == 32 ).length
              // -internStudentList.filter((el) => el.status_id == 14 ).length }
              qtyColorText="#00FF15"
            />

            <SummaryCardEl
              cardWidth="250px"
              setStatusFocused={setStatusFocused}
              statusFocused={statusFocused}
              setFilterList={setFilterList}
              setInternFilterTypeList={setInternFilterTypeList}
              status_id={100}
              data={internStudentList.filter(
                (el) =>
                  el.status_id == 0 ||
                  el.status_id == 14 ||
                  el.status_id == 15 ||
                  el.status_id == 32
              )}
              title="ยังไม่ได้ยื่นคำขอฝึกงาน"
              qtyColorText="#e01b22"
            />

            <SummaryCardEl
              cardWidth="250px"
              setStatusFocused={setStatusFocused}
              statusFocused={statusFocused}
              setFilterList={setFilterList}
              setInternFilterTypeList={setInternFilterTypeList}
              status_id={3}
              data={internStudentList.filter((el) => el.status_id == 3)}
              title="ส่งหนังสือออก / รอบริษัทตอบรับ"
              qtyColorText="#1876D1"
            />

            <SummaryCardEl
              cardWidth="250px"
              setStatusFocused={setStatusFocused}
              statusFocused={statusFocused}
              setFilterList={setFilterList}
              setInternFilterTypeList={setInternFilterTypeList}
              status_id={1}
              data={internStudentList.filter((el) => el.status_id == 1)}
              title="ยื่นคำขอฝึกงานแล้ว"
              qtyColorText="blue"
            />
            <SummaryCardEl
              cardWidth="250px"
              setStatusFocused={setStatusFocused}
              statusFocused={statusFocused}
              setFilterList={setFilterList}
              setInternFilterTypeList={setInternFilterTypeList}
              status_id={12}
              data={internStudentList.filter((el) => el.status_id == 12)}
              title="อนุมัติคำร้อง"
              qtyColorText="green"
            />
            <SummaryCardEl
              cardWidth="250px"
              setStatusFocused={setStatusFocused}
              statusFocused={statusFocused}
              setFilterList={setFilterList}
              setInternFilterTypeList={setInternFilterTypeList}
              status_id={2}
              data={internStudentList.filter((el) => el.status_id == 2)}
              title="เตรียมออกหนังสือขอความอนุเคราะห์"
              qtyColorText="orange"
            />
            <SummaryCardEl
              cardWidth="250px"
              setStatusFocused={setStatusFocused}
              statusFocused={statusFocused}
              setFilterList={setFilterList}
              setInternFilterTypeList={setInternFilterTypeList}
              status_id={21}
              data={internStudentList.filter((el) => el.status_id == 21)}
              title="ออกหนังสือขอความอนุเคราะห์แล้ว"
              qtyColorText="#F1D507"
            />

            <SummaryCardEl
              cardWidth="250px"
              setStatusFocused={setStatusFocused}
              statusFocused={statusFocused}
              setFilterList={setFilterList}
              setInternFilterTypeList={setInternFilterTypeList}
              status_id={11}
              data={internStudentList.filter((el) => el.status_id == 11)}
              title="ตรวจสอบสถานประกอบการใหม่"
              qtyColorText="#F7F759"
            />
          </div>

          <div className="card flex-fill">
            <div className="row">
              <div className="col-lg-12">{displayTable}</div>
            </div>
          </div>
        </div>
        {displayProfile}
      </main>
    </div>
  );

  const renderProgressByBranch = (stList = [], b_id) => {
    const filterList = stList.filter((st) => st.b_id === b_id);

    return (
      <div className="card shadow border-success">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <div>{matchOptions(optionsBranch, b_id)}</div>
            <div>
              {filterList.filter((el) => el.status_id != 0).length} /{" "}
              {filterList.length}
            </div>
          </div>

          <div className="progress">
            <ProgressBarEl
              stList={filterList}
              bgColor="#F7F759"
              statusId={11}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="blue"
              statusId={1}
              statusIdPrev={11}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="green"
              statusId={12}
              statusIdPrev={1}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="orange"
              statusId={2}
              statusIdPrev={12}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="#F1D507"
              statusId={21}
              statusIdPrev={2}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="#1876D1"
              statusId={3}
              statusIdPrev={21}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="#00FF15"
              statusId={31}
              statusIdPrev={3}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderInterntypeByBranch = (
    stList1 = [],
    b_id,
    stType1 = [],
    stType2 = [],
    stType3 = []
  ) => {
    const filterList1 = stList1.filter((st) => st.b_id === b_id);
    const ListType1 = stType1.filter((st) => st.b_id === b_id);
    const ListType2 = stType2.filter((st) => st.b_id === b_id);
    const ListType3 = stType3.filter((st) => st.b_id === b_id);

    return (
      <div className="card-body p-3">
        <div className="d-flex justify-content-between align-items-center">
          <div>{matchOptions(optionsBranch, b_id)}</div>
          <div>
            {ListType1.length} / {ListType2.length + ListType3.length}
          </div>
        </div>
        <div className="progress">
          <div
            className="progress-bar"
            role="progressbar"
            aria-label="type-1"
            style={{
              width: `${Math.round(
                (ListType1.length /
                  (filterList1.filter((el) => el.status_id != 0).length -
                    filterList1.filter((el) => el.status_id == 15).length -
                    filterList1.filter((el) => el.status_id == 32).length -
                    filterList1.filter((el) => el.status_id == 14).length)) *
                  100
              )}%`,
            }}
            aria-valuenow={Math.round(
              (ListType1.length /
                (filterList.filter((el) => el.status_id != 0).length -
                  filterList1.filter((el) => el.status_id == 15).length -
                  filterList1.filter((el) => el.status_id == 32).length -
                  filterList1.filter((el) => el.status_id == 14).length)) *
                100
            )}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            {`${Math.round(
              (ListType1.length /
                (filterList1.filter((el) => el.status_id != 0).length -
                  filterList1.filter((el) => el.status_id == 15).length -
                  filterList1.filter((el) => el.status_id == 32).length -
                  filterList1.filter((el) => el.status_id == 14).length)) *
                100
            )}% `}
          </div>

          <div
            className="progress-bar bg-success"
            role="progressbar"
            aria-label="type-2-3"
            style={{
              width: `${Math.round(
                ([...ListType2, ...ListType3].length /
                  (filterList1.filter((el) => el.status_id != 0).length -
                    filterList1.filter((el) => el.status_id == 15).length -
                    filterList1.filter((el) => el.status_id == 32).length -
                    filterList1.filter((el) => el.status_id == 14).length)) *
                  100
              )}%`,
            }}
            aria-valuenow={Math.round(
              (ListType1.length /
                (filterList1.filter((el) => el.status_id != 0).length -
                  filterList1.filter((el) => el.status_id == 15).length -
                  filterList1.filter((el) => el.status_id == 32).length -
                  filterList1.filter((el) => el.status_id == 14).length)) *
                100
            )}
            aria-valuemin={Math.round(
              ([...ListType2, ...ListType3].length /
                (filterList1.filter((el) => el.status_id != 0).length -
                  filterList1.filter((el) => el.status_id == 15).length -
                  filterList1.filter((el) => el.status_id == 32).length -
                  filterList1.filter((el) => el.status_id == 14).length)) *
                100
            )}
            aria-valuemax={100}
            aria-valuetext={"a"}
          >
            {" "}
            {`${Math.round(
              ([...ListType2, ...ListType3].length /
                (filterList1.filter((el) => el.status_id != 0).length -
                  filterList1.filter((el) => el.status_id == 15).length -
                  filterList1.filter((el) => el.status_id == 32).length -
                  filterList1.filter((el) => el.status_id == 14).length)) *
                100
            )}% `}{" "}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div>
        {displayDashboard}
        <ModalCrudCompany2
          setIsOpen={setIsOpenModal}
          modalIsOpen={isOpenModal}
        />
        <ModalView
          isModaOpen={modalChartOpen}
          setIsModalOpen={setModalChartOpen}
          title={
            <span>
              <h4 className="d-inline">สถานะการฝึกงานของนิสิต</h4>
              <span className="text-secondary ms-2">
                updated : {dayjs().format("DD/MM/YYYY HH:mm")}
              </span>
            </span>
          }
        >
          <Box minWidth={800}>
            <Grid container>
              <Grid item xs={12} md={6}>
                {renderProgressByBranch(internStudentList2, "1")}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderProgressByBranch(internStudentList2, "2")}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderProgressByBranch(internStudentList2, "3")}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderProgressByBranch(internStudentList2, "4")}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderProgressByBranch(internStudentList2, "5")}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderProgressByBranch(internStudentList2, "6")}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderProgressByBranch(internStudentList2, "7")}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderProgressByBranch(internStudentList2, "8")}
              </Grid>
            </Grid>
          </Box>
        </ModalView>
      </div>
      <div>
        <ModalCrudCompany2
          setIsOpen={setIsOpenModal2}
          modalIsOpen={isOpenModal2}
        />
        <ModalView
          isModaOpen={modalChartOpen2}
          setIsModalOpen={setModalChartOpen2}
          title={
            <span>
              <h4 className="d-inline">รูปแบบการฝึกงานและสหกิจศึกษา</h4>
              <span className="text-secondary ms-2">
                updated : {dayjs().format("DD/MM/YYYY HH:mm")}
              </span>{" "}
              {"  "}
              <span className="text-primary">ฝึกงาน 2 เดือน</span> {" / "}
              <span className="text-success">สหกิจศึกษา</span>
            </span>
          }
        >
          <Box minWidth={800}>
            <Grid container>
              <Grid item xs={12} md={6}>
                {renderInterntypeByBranch(
                  internStudentList3,
                  "1",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderInterntypeByBranch(
                  internStudentList3,
                  "2",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderInterntypeByBranch(
                  internStudentList3,
                  "3",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderInterntypeByBranch(
                  internStudentList3,
                  "4",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderInterntypeByBranch(
                  internStudentList3,
                  "5",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderInterntypeByBranch(
                  internStudentList3,
                  "6",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderInterntypeByBranch(
                  internStudentList3,
                  "7",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {renderInterntypeByBranch(
                  internStudentList3,
                  "8",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </Grid>
            </Grid>
          </Box>
        </ModalView>
      </div>
    </>
  );
};

export default Dashboard;
